import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '5234414',
  title: 'Aprenda e Lucre com nossos Sinais Ao Vivo',
  video: { platform: 'youtube', videoId: 'LTa-T2I8fXk' },
  article: ['Descrição da aula.'],
};
export default lesson;

